import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalPainDataService} from './impl/service/ngxr/medicalPainData.service';
import {MedicalPainRepository} from './impl/service/ngxr/medicalPain.repository';
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from '../../../ai/realtime/api/service/aiRealtime.service';

@NgModule({
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_pains_to_consultation',
                    runningLabel: 'Ajout d\'une douleur en cours',
                    errorLabel: 'Erreur lors de l’ajout de douleurs',
                    successLabel: 'Douleur(s) ajoutée(s)',
                    appEventNames: ['medicalPain']
                } as AiRealtimeToolDefinition],
            multi: true,
        }
    ]
})
export class MedicalRecordPainModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalPainDataService,
                service: MedicalPainRepository,
    ) {

        entityDataService.registerServices({
            MedicalPain: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalPain: service,
        });


    }
}
